import { ColorResult } from "react-color";

import general from "constants/general";
import getHslFromRgba from "./getHslFromRgba";

const getEffectColorByOrg = (organization?: string): ColorResult => {
  if (organization === "Merck" || organization === "MSD") {
    return {
      hex: "#00857C",
      rgb: { r: 0, g: 133, b: 124, a: 1 },
      hsl: getHslFromRgba({ r: 0, g: 133, b: 124, a: 1 })
    };
  }

  if (organization === "Synopsys" || organization === "Synopsys Private Workspace") {
    return {
      hex: "#5A2A82",
      rgb: { r: 90, g: 42, b: 130, a: 1 },
      hsl: { a: 1, h: 273, l: 0.34, s: 0.51 }
    };
  }

  return general.DEFAULT_COLOR;
};

export default getEffectColorByOrg;
